import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { COLORS } from '@/nova/theme/tokens';

/* The beat-preview modal body: the beat's clip (or its still end frame) in an aspect-locked frame,
   then a compact role / motion / duration meta list. Colours come only from theme tokens. */
export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

/** Aspect-locked frame. Landscape fills the column; portrait is capped so it doesn't dominate. */
export const Frame = styled.div<{ $ratio: number }>`
  position: relative;
  width: 100%;
  max-width: ${(p) => (p.$ratio >= 1 ? '100%' : '280px')};
  aspect-ratio: ${(p) => p.$ratio};
  margin-inline: auto;
  border-radius: 14px;
  overflow: hidden;
  background: ${COLORS.surfaceInset};
  border: 1px solid ${COLORS.hairline};
`;

export const Video = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: ${COLORS.pageBg};
`;

export const StillImg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

/** Shown when neither a clip nor an end-frame still exists yet for the beat. */
export const Placeholder = styled.div<{ $ratio: number }>`
  width: 100%;
  max-width: ${(p) => (p.$ratio >= 1 ? '100%' : '280px')};
  aspect-ratio: ${(p) => p.$ratio};
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 14px;
  color: ${COLORS.textFaint};
  background: ${COLORS.surfaceInset};
  border: 1px dashed ${COLORS.hairline};
`;

export const PlaceholderText = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 12px;
  color: ${COLORS.textFaint};
`;

/** Why Regenerate is disabled (a mature primary art style): a muted note beside the footer button. */
export const FootHint = styled(Text).attrs({ tag: 'span' as const })`
  align-self: center;
  font-size: 13px;
  color: ${COLORS.textFaint};
`;

export const MetaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MetaRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: baseline;
`;

export const MetaLabel = styled(Text).attrs({ tag: 'span' as const })`
  flex: 0 0 88px;
  font-size: 12px;
  font-weight: 600;
  color: ${COLORS.textMuted};
`;

export const MetaValue = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 13px;
  color: ${COLORS.text};
`;
